import { buildTask as _buildTask } from "ember-concurrency/-private/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
// TODO: AP-26869 Refactor this into new package
import { didCancel, task } from 'ember-concurrency';
import { copy } from 'ember-copy';
import { A } from '@ember/array';
import { action } from '@ember/object';
import Service, { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import * as Sentry from '@sentry/ember';
import { SupportedCountry } from '@square/appointments-feature-upsell/utils/localizations-junk-drawer';
import { convertUrlToImageFile } from '@square/dashboard-utilities/utils/file';
function logPrimaryBusinessLocationUndefined() {
  const businessLocationUndefinedError = new Error('AppointmentsLocations Service: primary business location is undefined');
  Sentry.captureException(businessLocationUndefinedError);
  throw businessLocationUndefinedError;
}
let AppointmentsLocations = (_class = class AppointmentsLocations extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "appointmentsSubscription", _descriptor, this);
    _initializerDefineProperty(this, "store", _descriptor2, this);
    _initializerDefineProperty(this, "jpStateOptions", _descriptor3, this);
    _defineProperty(this, "squareBusinessLocationCount", void 0);
    _defineProperty(this, "loadedBusinessLocation", void 0);
    _defineProperty(this, "primaryBusinessLocation", void 0);
    _defineProperty(this, "fetchBusinessLocationTask", _buildTask(() => ({
      context: this,
      generator: function* (businessLocationUnitToken, countryCode) {
        yield this.fetchBusinessLocation(businessLocationUnitToken, countryCode);
      }
    }), null, "fetchBusinessLocationTask", null));
    _defineProperty(this, "fetchPrimaryBusinessLocationTask", _buildTask(() => ({
      context: this,
      generator: function* (primaryLocationUnitToken, countryCode) {
        if (!primaryLocationUnitToken) {
          throw new Error(`AppointmentsLocations Service > fetchPrimaryBusinessLocationTask: unit token arg cannot be ${primaryLocationUnitToken}`);
        }
        yield this.fetchPrimaryBusinessLocation(primaryLocationUnitToken, countryCode);
      }
    }), null, "fetchPrimaryBusinessLocationTask", null));
    _defineProperty(this, "_fetchSquareBusinessLocationCount", _buildTask(() => ({
      context: this,
      generator: function* () {
        try {
          const squareBusinessLocations = yield this.store.findAll('merchant-subunit-detailed');
          this.squareBusinessLocationCount = squareBusinessLocations.toArray().length;
        } catch (err) {
          Sentry.withScope(scope => {
            scope.setExtra('err', err);
            Sentry.captureException(new Error('AppointmentsLocations Service: error fetching square business locations'));
          });
          throw err;
        }
      }
    }), null, "_fetchSquareBusinessLocationCount", null));
  }
  async fetchSquareBusinessLocationCount() {
    if (!this.squareBusinessLocationCount) {
      await this._fetchSquareBusinessLocationCount.perform().catch(err => {
        // Check for task cancellation error, should refactor in the future as is an antipattern
        // source: http://ember-concurrency.com/docs/task-cancelation-help
        if (!didCancel(err)) {
          // Error already logged below
          throw err;
        }
      });
    }
  }
  async _fetchJPStateOptionsForBusinessLocation(businessLocation, countryCode) {
    if (!businessLocation) {
      throw new Error('AppointmentsLocations Service: business location is undefined');
    }
    try {
      // For more info, visit https://docs.google.com/document/d/1I7x-vnqeZ6zNHw3TfX_RHgM3sSV0DoXVC95sg0HeM1c/edit
      if (countryCode === SupportedCountry.JP && businessLocation.merchantProfile?.postalCode) {
        this.jpStateOptions = await this.store.queryRecord('jp-state', {
          q: businessLocation.merchantProfile.postalCode,
          tree: 2
        });
      }
    } catch (err) {
      Sentry.withScope(scope => {
        scope.setExtra('err', err);
        Sentry.captureException(new Error('AppointmentsLocations Service: error fetching JP state options for business location'));
      });
      throw err;
    }
  }

  // Modeled off of similar functionality in dashboard/lib/account-settings/routes/locations-list/new
  _setDefaultMerchantProfileFromPrimaryLocation(newLocation) {
    if (!this.primaryBusinessLocation) {
      throw logPrimaryBusinessLocationUndefined();
    }

    // Avoiding param reassignment eslint error
    const newLocationToUpdate = newLocation;
    const newHours = this.primaryBusinessLocation.merchantProfile.hours.map(hours => copy(hours));
    if (this.primaryBusinessLocation?.merchantProfile?.profileImage?.original_url !== undefined) {
      convertUrlToImageFile(this.primaryBusinessLocation.merchantProfile.profileImage.original_url).then(result => {
        const loadedImage = result;
        loadedImage.file.square200_url = result?.data || '';
        newLocationToUpdate.merchantProfile.profileImage = result.file;
      });
    }
    if (this.primaryBusinessLocation?.merchantProfile?.profileBannerImage?.original_url !== undefined) {
      convertUrlToImageFile(this.primaryBusinessLocation.merchantProfile.profileBannerImage.original_url).then(result => {
        const loadedImage = result;
        loadedImage.file.original_url = result?.data || '';
        newLocationToUpdate.merchantProfile.profileBannerImage = result.file;
      });
    }
    newLocationToUpdate.merchantProfile.bio = this.primaryBusinessLocation.merchantProfile.bio;
    newLocationToUpdate.merchantProfile.facebook = this.primaryBusinessLocation.merchantProfile.facebook;
    newLocationToUpdate.merchantProfile.twitter = this.primaryBusinessLocation.merchantProfile.twitter;
    newLocationToUpdate.merchantProfile.jpQiiNumber = this.primaryBusinessLocation.merchantProfile.jpQiiNumber;
    newLocationToUpdate.merchantProfile.instagram = this.primaryBusinessLocation.merchantProfile.instagram;
    newLocationToUpdate.merchantProfile.mobileBusiness = this.primaryBusinessLocation.merchantProfile.mobileBusiness;
    newLocationToUpdate.merchantProfile.ianaTimeZone = this.primaryBusinessLocation.merchantProfile.ianaTimeZone;
    newLocationToUpdate.merchantProfile.email = this.primaryBusinessLocation.merchantProfile.email;
    newLocationToUpdate.merchantProfile.hours = A(newHours);
    newLocationToUpdate.merchantProfile.phone = this.primaryBusinessLocation.merchantProfile.phone;
    newLocationToUpdate.merchantProfile.website = this.primaryBusinessLocation.merchantProfile.website;

    // We only allow png and jpeg images for merchant profiles,
    // but some old accounts have the wrong kind of images
    // Fix for ONCALL-107129
    const filteredMerchantImages = this.primaryBusinessLocation.merchantProfile.merchantImages.filter(function (item) {
      return item.url.endsWith('jpeg') || item.url.endsWith('png');
    });
    newLocationToUpdate.merchantProfile.merchantImages = filteredMerchantImages;
    newLocationToUpdate.merchantProfile.posTerminalImages = this.primaryBusinessLocation.merchantProfile.posTerminalImages;

    // Autofill merchant name in new location
    newLocationToUpdate.merchantProfile.name = this.primaryBusinessLocation.merchantProfile.name;

    // Autofill merchant language in new location
    newLocationToUpdate.merchantProfile.preferredLanguage = this.primaryBusinessLocation.merchantProfile.preferredLanguage;

    // Autofill merchant country code in new location
    newLocationToUpdate.merchantProfile.countryCode = this.primaryBusinessLocation.merchantProfile.countryCode;
  }
  async fetchBusinessLocation(businessLocationUnitToken, countryCode) {
    let businessLocation;
    this.loadedBusinessLocation = undefined;
    try {
      businessLocation = await this.store.queryRecord('merchant-subunit-detailed', {
        token: businessLocationUnitToken
      });
    } catch (err) {
      Sentry.withScope(scope => {
        scope.setExtra('err', err);
        Sentry.captureException(new Error('AppointmentsLocations Service: error fetching business location'));
      });
      throw err;
    }
    await this._fetchJPStateOptionsForBusinessLocation(businessLocation, countryCode);
    this.loadedBusinessLocation = businessLocation;
    return businessLocation;
  }
  async fetchPrimaryBusinessLocation(primaryLocationUnitToken, countryCode) {
    this.primaryBusinessLocation = await this.fetchBusinessLocation(primaryLocationUnitToken, countryCode);
  }
  createLocation(locationState, countryCode) {
    const newLocation = this.store.createRecord('merchant-subunit-detailed', {
      merchantProfile: this.store.createRecord('merchant-profile', {
        merchantImages: []
      })
    });

    // Autofill Merchant profile from main unit
    this._setDefaultMerchantProfileFromPrimaryLocation(newLocation);
    return this.updateLocation(newLocation, locationState, countryCode);
  }
  async updateLocation(businessLocation, locationState, countryCode) {
    // Assign to local variable to avoid no-param-reassign eslint error
    const businessLocationToUpdate = businessLocation;
    if (countryCode === SupportedCountry.JP) {
      businessLocationToUpdate.merchantProfile.street1 = locationState.addressInfo.sublocality;
    } else {
      businessLocationToUpdate.merchantProfile.street1 = locationState.addressInfo.addressLine1;
    }
    businessLocationToUpdate.merchantProfile.name = locationState.businessName;
    businessLocationToUpdate.nickname = locationState.businessNickname || '';
    businessLocationToUpdate.merchantProfile.mobileBusiness = locationState.isMobileBusiness;
    businessLocationToUpdate.merchantProfile.street2 = locationState.addressInfo.addressLine2;
    businessLocationToUpdate.merchantProfile.city = locationState.addressInfo.city;
    businessLocationToUpdate.merchantProfile.state = locationState.addressInfo.state;
    businessLocationToUpdate.merchantProfile.postalCode = locationState.addressInfo.zipcode;
    businessLocationToUpdate.merchantProfile.phone = locationState.phoneNumber;
    businessLocationToUpdate.merchantProfile.addressLine3 = locationState.addressInfo.addressLine3;
    // The following ts-ignore usages are necessary as typescript believes hasDirtyAttributes to
    // be a function, and that this will always evaluate to true
    if (/* eslint-disable @typescript-eslint/ban-ts-comment */
    // @ts-ignore
    businessLocationToUpdate.hasDirtyAttributes ||
    // @ts-ignore
    businessLocationToUpdate.merchantProfile.hasDirtyAttributes
    /* eslint-enable @typescript-eslint/ban-ts-comment */) {
      try {
        await businessLocationToUpdate.save();
      } catch (err) {
        Sentry.withScope(scope => {
          scope.setExtra('err', err);
          Sentry.captureException(new Error('AppointmentsLocations Service: error saving business location'));
        });
        throw err;
      }
    }
    return businessLocationToUpdate;
  }
  updatePrimaryLocation(locationState, countryCode) {
    if (!this.primaryBusinessLocation) {
      throw logPrimaryBusinessLocationUndefined();
    }
    return this.updateLocation(this.primaryBusinessLocation, locationState, countryCode);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "appointmentsSubscription", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "jpStateOptions", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "createLocation", [action], Object.getOwnPropertyDescriptor(_class.prototype, "createLocation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateLocation", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateLocation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updatePrimaryLocation", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updatePrimaryLocation"), _class.prototype), _class);
export { AppointmentsLocations as default };